import { render, staticRenderFns } from "./Conjugations.vue?vue&type=template&id=19fe578c&"
import script from "./Conjugations.vue?vue&type=script&lang=js&"
export * from "./Conjugations.vue?vue&type=script&lang=js&"
import style0 from "./Conjugations.vue?vue&type=style&index=0&id=19fe578c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports